// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// APPLICATION SCOPING SCHEMA
/////////////////////////////////////////

export const ApplicationScopingSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  fullApplicationDescription: z.string().nullable(),
  applicationTestingPlan: z.string().array(),
  applicationRisks: z.string().array(),
  webApplicationName: z.string().nullable(),
  webApplicationUrl: z.string().nullable(),
  desiredStartDate: z.string().nullable(),
  desiredFinishDate: z.string().nullable(),
  contactName: z.string().nullable(),
  contactEmail: z.string().nullable(),
  serverSideLanguage: z.string().nullable(),
  frameworkType: z.string().nullable(),
  frameworkName: z.string().nullable(),
  clientSideTechnologies: z.string().array(),
  hasSinglePageApplications: z.boolean().nullable(),
  dataTypes: z.string().array(),
  applicationFunctionality: z.string().nullable(),
  numberOfPages: z.number().int().nullable(),
  numberOfApiEndpoints: z.number().int().nullable(),
  hasApiDocumentation: z.boolean().nullable(),
  databases: z.string().array(),
  userRoles: z.string().array(),
  hasSelfRegister: z.boolean().nullable(),
  isHostedInCloud: z.boolean().nullable(),
  cloudProvider: z.string().nullable(),
  timeConstraints: z.string().nullable(),
  testingEnvironment: z.string().nullable(),
  canAffectProduction: z.boolean().nullable(),
  requiresVpn: z.boolean().nullable(),
  requiresIpWhitelist: z.boolean().nullable(),
  authenticationMechanisms: z.string().array(),
  outOfScopeFeatures: z.string().array(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ApplicationScoping = z.infer<typeof ApplicationScopingSchema>

export default ApplicationScopingSchema;
